// Keep the review tied to the exact applicant details, including additions/removals.
export const historyIdentity = (applicants) => JSON.stringify((applicants || []).map((person) => ({
  ...person,
  socialSecurity: String(person?.socialSecurity || "").replace(/-/g, ""),
  dateOfBirth: person?.dateOfBirth?.format?.("YYYY-MM-DD") || person?.dateOfBirth,
})));

export const hasCurrentHistoryReview = (reviewedIdentity, applicants) =>
  Boolean(reviewedIdentity && applicants?.length && reviewedIdentity === historyIdentity(applicants));
